export default "__VITE_ASSET__3a3ac335__"